import { NativeStackScreenProps } from "@react-navigation/native-stack";

export type ParamList = {
  PreviewScreen: { slug: string };
  ActivityFormScreen: { slug: string };
  PdrHistory: { slug: string };
  ReportPDR: { slug: string };
  PdrDetails: { id: string };
};

export enum SlugList {
  "golf-coach" = "M07",
  "media-related-articles" = "M09",
  "service-to-pga-industry" = "M06",
}

export type Slug = keyof typeof SlugList;

export type ScreenProps<name extends keyof ParamList> = NativeStackScreenProps<ParamList, name>;
